module.exports = __webpack_public_path__ + "img/ball_4.32501167.svg";